
import { FormControl, FormDescription, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue
} from "@/components/ui/select";
import { Control } from "react-hook-form";
import { FormValues } from "./types";

interface MetalSelectProps {
  control: Control<FormValues>;
  currentGoldPrice: number | undefined;
  currentSilverPrice: number | undefined;
  onMetalChange: (value: "gold" | "silver") => void;
}

export function MetalSelect({ control, onMetalChange, currentGoldPrice, currentSilverPrice }: MetalSelectProps) {
  return (
    <FormField
      control={control}
      name="metal"
      render={({ field }) => (
        <FormItem>
          <FormLabel>Metallo</FormLabel>
          <Select 
            onValueChange={(value: "gold" | "silver") => {
              field.onChange(value);
              onMetalChange(value);
            }}
            defaultValue={field.value}
          >
            <FormControl>
              <SelectTrigger>
                <SelectValue placeholder="Seleziona metallo" />
              </SelectTrigger>
            </FormControl>
            <SelectContent>
              <SelectItem value="gold">Oro</SelectItem>
              <SelectItem value="silver">Argento</SelectItem>
            </SelectContent>
          </Select>
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
